import { isNode } from "@use/is-node";

/**
 * Safely returns a high resolution timestamp in both node.js and browsers.
 */
export function hrtime(): number {
    // tslint:disable-next-line no-typeof-undefined
    if (!isNode()) {
        // Use built-in performance.now() in modern browsers
        return performance.now();
    }

    // Fall back to node.js high resolution time (we're using eval to prevent
    // Webpack from grabbing our reference to process)
    const hrTime = <[number, number]> eval("process.hrtime()"); // tslint:disable-line no-eval

    // Convert to a number given in milliseconds
    return hrTime[0] * 1000 + hrTime[1] / 1000000;
}
